// 공통 UI 상수 및 헬퍼 (문의 상태/서비스 뱃지, 이름 마스킹)

export const STATUS_BADGES: Record<string, string> = {
  접수: "bg-foreground-100 text-foreground-700",
  처리중: "bg-accent-100 text-accent-800",
  완료: "bg-secondary-100 text-secondary-800",
};

export const SERVICE_BADGES: Record<string, string> = {
  "원목칩 파쇄": "bg-primary-100 text-primary-800",
  "가지칩 파쇄": "bg-accent-100 text-accent-800",
  "뿌리 파쇄": "bg-secondary-100 text-secondary-800",
  "자원 재활용 컨설팅": "bg-foreground-100 text-foreground-800",
};

export function getStatusBadge(status?: string): string {
  return STATUS_BADGES[status || ""] || STATUS_BADGES["접수"];
}

export function getServiceBadge(service?: string): string {
  return SERVICE_BADGES[service || ""] || "bg-foreground-100 text-foreground-700";
}

export function maskName(name?: string): string {
  if (!name) return "익명";
  if (name.length <= 1) return name;
  return name[0] + "*".repeat(name.length - 1);
}